// See designSystemClickTracking.md for the full contract and architecture.

export const VC_CLICK_EVENT = 'vc-click';
export const BUTTON_CLICKED_EVENT = 'Button Clicked';

/**
 * Sends every design-system click announced on the root instance as a "Button Clicked" event.
 * @param {import('vue').default} root The root Vue instance, which has `$track`.
 * @returns {void}
 */
export const listenToDesignSystemClicks = (root) => {
  root.$on(VC_CLICK_EVENT, ({ id, component, action } = {}) => {
    if (!id) return;
    root.$track(BUTTON_CLICKED_EVENT, { button_id: id, component, action });
  });
};
